<template>
  <div data-dusk="card-stacked-list" class="card-stacked-list">
    <template v-if="listGiven" v-for="(row, key) in twoColumnedlist">
      <div class="list-row">
        <div data-dusk="card-stacked-list-item" class="list-value" v-for="(col, idx) in row" >
          <span class="key">{{ col.key }}</span>
          <span v-html="sanitize(col.value)" class="value"></span>
        </div>
      </div>
      <hr class="divider">
    </template>
    <slot></slot>
  </div>
</template>

<script>
import DOMPurify from "dompurify";

export default {
  name: "CardStackedList.vue",
  props: {
    list: [Object, Array],
  },
  methods: {
    sanitize(value) {
      return DOMPurify.sanitize(value);
    }
  },
  computed: {
    listGiven() {
      if (!this.list) return false;
      return Object.keys(this.list).length > 0;
    },
    twoColumnedlist() {
      if (this.listGiven === false) return;
      let list = {};
      let idx = 0;
      let rowCount = 0;
      Object.entries(this.list).forEach(([key,value]) => {
        rowCount ++ ;
        if (!(idx in list)) list[idx] = {};
        if (!(rowCount in list[idx])) list[idx][rowCount] = {};
        list[idx][rowCount] = {key, value};
        if (rowCount === 2) {
          idx += 1;
          rowCount = 0;
        }
      });
      return list;
    }
  },
}
</script>

<style lang="scss">
@import "~@/_default.scss";

.card-stacked-list {
  width: 100%;
  display: flex;
  flex-direction: column;

  .list-row {
    display: flex;
    justify-content: space-between;
  }

  .list-value {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: $spacing-md 0;
    flex: 0.5;
    .key {
      font-weight: 400;
      font-size: 13px;
      color: $brand-primary;
    }

    .value {
      font-weight: 400;
      font-size: 15px;
      color: $text-color;
    }
  }
  .divider {
    margin: 0;
    border: 1px solid #EEF2F6;
  }

  .divider:last-of-type {
    display: none;
  }
}

</style>